/*
 * Generated by PEG.js 0.10.0.
 *
 * http://pegjs.org/
 */
"use strict";

function peg$subclass(child, parent) {
  function ctor() {
    this.constructor = child;
  }

  ctor.prototype = parent.prototype;
  child.prototype = new ctor();
}

function peg$SyntaxError(message, expected, found, location) {
  this.message = message;
  this.expected = expected;
  this.found = found;
  this.location = location;
  this.name = "SyntaxError";

  if (typeof Error.captureStackTrace === "function") {
    Error.captureStackTrace(this, peg$SyntaxError);
  }
}

peg$subclass(peg$SyntaxError, Error);

peg$SyntaxError.buildMessage = function (expected, found) {
  var DESCRIBE_EXPECTATION_FNS = {
    literal: function literal(expectation) {
      return "\"" + literalEscape(expectation.text) + "\"";
    },
    "class": function _class(expectation) {
      var escapedParts = "",
          i;

      for (i = 0; i < expectation.parts.length; i++) {
        escapedParts += expectation.parts[i] instanceof Array ? classEscape(expectation.parts[i][0]) + "-" + classEscape(expectation.parts[i][1]) : classEscape(expectation.parts[i]);
      }

      return "[" + (expectation.inverted ? "^" : "") + escapedParts + "]";
    },
    any: function any(expectation) {
      return "any character";
    },
    end: function end(expectation) {
      return "end of input";
    },
    other: function other(expectation) {
      return expectation.description;
    }
  };

  function hex(ch) {
    return ch.charCodeAt(0).toString(16).toUpperCase();
  }

  function literalEscape(s) {
    return s.replace(/\\/g, '\\\\').replace(/"/g, '\\"').replace(/\0/g, '\\0').replace(/\t/g, '\\t').replace(/\n/g, '\\n').replace(/\r/g, '\\r').replace(/[\x00-\x0F]/g, function (ch) {
      return '\\x0' + hex(ch);
    }).replace(/[\x10-\x1F\x7F-\x9F]/g, function (ch) {
      return '\\x' + hex(ch);
    });
  }

  function classEscape(s) {
    return s.replace(/\\/g, '\\\\').replace(/\]/g, '\\]').replace(/\^/g, '\\^').replace(/-/g, '\\-').replace(/\0/g, '\\0').replace(/\t/g, '\\t').replace(/\n/g, '\\n').replace(/\r/g, '\\r').replace(/[\x00-\x0F]/g, function (ch) {
      return '\\x0' + hex(ch);
    }).replace(/[\x10-\x1F\x7F-\x9F]/g, function (ch) {
      return '\\x' + hex(ch);
    });
  }

  function describeExpectation(expectation) {
    return DESCRIBE_EXPECTATION_FNS[expectation.type](expectation);
  }

  function describeExpected(expected) {
    var descriptions = new Array(expected.length),
        i,
        j;

    for (i = 0; i < expected.length; i++) {
      descriptions[i] = describeExpectation(expected[i]);
    }

    descriptions.sort();

    if (descriptions.length > 0) {
      for (i = 1, j = 1; i < descriptions.length; i++) {
        if (descriptions[i - 1] !== descriptions[i]) {
          descriptions[j] = descriptions[i];
          j++;
        }
      }

      descriptions.length = j;
    }

    switch (descriptions.length) {
      case 1:
        return descriptions[0];

      case 2:
        return descriptions[0] + " or " + descriptions[1];

      default:
        return descriptions.slice(0, -1).join(", ") + ", or " + descriptions[descriptions.length - 1];
    }
  }

  function describeFound(found) {
    return found ? "\"" + literalEscape(found) + "\"" : "end of input";
  }

  return "Expected " + describeExpected(expected) + " but " + describeFound(found) + " found.";
};

function peg$parse(input, options) {
  options = options !== void 0 ? options : {};

  var peg$FAILED = {},
      peg$startRuleFunctions = {
    start: peg$parsestart,
    start_text: peg$parsestart_text
  },
      peg$startRuleFunction = peg$parsestart,
      peg$c0 = function peg$c0(parts) {
    return new Expression.TextExpression(parts);
  },
      peg$c1 = "${",
      peg$c2 = peg$literalExpectation("${", false),
      peg$c3 = "}{",
      peg$c4 = peg$literalExpectation("}{", false),
      peg$c5 = /^[^}]/,
      peg$c6 = peg$classExpectation(["}"], true, false),
      peg$c7 = "}",
      peg$c8 = peg$literalExpectation("}", false),
      peg$c9 = function peg$c9(expr, format) {
    return {
      expression: expr,
      format: flatten(format)
    };
  },
      peg$c10 = function peg$c10(expr) {
    return {
      expression: expr
    };
  },
      peg$c11 = function peg$c11(str) {
    return {
      string: str.join("")
    };
  },
      peg$c12 = /^[^$\\]/,
      peg$c13 = peg$classExpectation(["$", "\\"], true, false),
      peg$c14 = function peg$c14(str) {
    return flatten(str);
  },
      peg$c15 = "\\",
      peg$c16 = peg$literalExpectation("\\", false),
      peg$c17 = /^[$\\]/,
      peg$c18 = peg$classExpectation(["$", "\\"], false, false),
      peg$c19 = function peg$c19(p) {
    return flatten(p);
  },
      peg$c20 = function peg$c20(expr) {
    return expr;
  },
      peg$c21 = peg$otherExpectation("operator"),
      peg$c22 = "and",
      peg$c23 = peg$literalExpectation("and", false),
      peg$c24 = "or",
      peg$c25 = peg$literalExpectation("or", false),
      peg$c26 = ">=",
      peg$c27 = peg$literalExpectation(">=", false),
      peg$c28 = ">",
      peg$c29 = peg$literalExpectation(">", false),
      peg$c30 = "<=",
      peg$c31 = peg$literalExpectation("<=", false),
      peg$c32 = "<",
      peg$c33 = peg$literalExpectation("<", false),
      peg$c34 = "==",
      peg$c35 = peg$literalExpectation("==", false),
      peg$c36 = "!=",
      peg$c37 = peg$literalExpectation("!=", false),
      peg$c38 = "in",
      peg$c39 = peg$literalExpectation("in", false),
      peg$c40 = "+",
      peg$c41 = peg$literalExpectation("+", false),
      peg$c42 = "-",
      peg$c43 = peg$literalExpectation("-", false),
      peg$c44 = "*",
      peg$c45 = peg$literalExpectation("*", false),
      peg$c46 = "/",
      peg$c47 = peg$literalExpectation("/", false),
      peg$c48 = "^",
      peg$c49 = peg$literalExpectation("^", false),
      peg$c50 = "not",
      peg$c51 = peg$literalExpectation("not", false),
      peg$c52 = function peg$c52(expr) {
    return create_operator("not", expr);
  },
      peg$c53 = function peg$c53(left, others) {
    return gen_operator(left, others);
  },
      peg$c54 = function peg$c54(op, expr) {
    return create_operator(flatten(op), expr);
  },
      peg$c55 = peg$otherExpectation("\"(\""),
      peg$c56 = "(",
      peg$c57 = peg$literalExpectation("(", false),
      peg$c58 = peg$otherExpectation("\")\""),
      peg$c59 = ")",
      peg$c60 = peg$literalExpectation(")", false),
      peg$c61 = peg$otherExpectation("\",'"),
      peg$c62 = ",",
      peg$c63 = peg$literalExpectation(",", false),
      peg$c64 = peg$otherExpectation("."),
      peg$c65 = ".",
      peg$c66 = peg$literalExpectation(".", false),
      peg$c67 = function peg$c67(expr, fields) {
    return new Expression.FieldAccess(expr, fields.map(function (f) {
      return f[3];
    }));
  },
      peg$c68 = function peg$c68(name, names) {
    return [name].concat(names.map(function (x) {
      return x[1];
    }));
  },
      peg$c69 = peg$otherExpectation("variable"),
      peg$c70 = function peg$c70(name) {
    return new Expression.Variable(name);
  },
      peg$c71 = function peg$c71(expr) {
    return [expr];
  },
      peg$c72 = function peg$c72(expr, other) {
    return [expr].concat(other);
  },
      peg$c73 = function peg$c73(source_args) {
    var args = [];

    for (var i = 0; i < source_args.length; i++) {
      if (source_args[i].length == 2) {} else {
        args.push(source_args[i][0]);
      }
    }

    return args;
  },
      peg$c74 = function peg$c74() {
    return [];
  },
      peg$c75 = function peg$c75(funcname, arglist) {
    return new Expression.FunctionCall(funcname, arglist);
  },
      peg$c76 = "=>",
      peg$c77 = peg$literalExpectation("=>", false),
      peg$c78 = function peg$c78(argNames, expr) {
    return new Expression.LambdaFunction(expr, argNames);
  },
      peg$c79 = function peg$c79(argName, expr) {
    return new Expression.LambdaFunction(expr, [argName]);
  },
      peg$c80 = peg$otherExpectation("value"),
      peg$c81 = peg$otherExpectation("floating point"),
      peg$c82 = /^[+\-]/,
      peg$c83 = peg$classExpectation(["+", "-"], false, false),
      peg$c84 = /^[0-9]/,
      peg$c85 = peg$classExpectation([["0", "9"]], false, false),
      peg$c86 = /^[eE]/,
      peg$c87 = peg$classExpectation(["e", "E"], false, false),
      peg$c88 = function peg$c88(str) {
    return new Expression.NumberValue(parseFloat(flatten(str)));
  },
      peg$c89 = peg$otherExpectation("boolean"),
      peg$c90 = "true",
      peg$c91 = peg$literalExpectation("true", false),
      peg$c92 = function peg$c92() {
    return new Expression.BooleanValue(true);
  },
      peg$c93 = "false",
      peg$c94 = peg$literalExpectation("false", false),
      peg$c95 = function peg$c95() {
    return new Expression.BooleanValue(false);
  },
      peg$c96 = peg$otherExpectation("string"),
      peg$c97 = "\"",
      peg$c98 = peg$literalExpectation("\"", false),
      peg$c99 = /^[^"]/,
      peg$c100 = peg$classExpectation(["\""], true, false),
      peg$c101 = function peg$c101(repr) {
    var str = JSON.parse(flatten(repr));
    return new Expression.StringValue(str);
  },
      peg$c102 = peg$otherExpectation("name"),
      peg$c103 = /^[a-zA-Z_]/,
      peg$c104 = peg$classExpectation([["a", "z"], ["A", "Z"], "_"], false, false),
      peg$c105 = /^[a-zA-Z0-9_]/,
      peg$c106 = peg$classExpectation([["a", "z"], ["A", "Z"], ["0", "9"], "_"], false, false),
      peg$c107 = function peg$c107(name) {
    return flatten(name);
  },
      peg$c108 = "`",
      peg$c109 = peg$literalExpectation("`", false),
      peg$c110 = /^[^`]/,
      peg$c111 = peg$classExpectation(["`"], true, false),
      peg$c112 = function peg$c112(repr) {
    return JSON.parse(flatten(repr).replace(/\`/g, "\""));
  },
      peg$c113 = peg$otherExpectation("whitespace"),
      peg$c114 = /^[ \n]/,
      peg$c115 = peg$classExpectation([" ", "\n"], false, false),
      peg$currPos = 0,
      peg$savedPos = 0,
      peg$posDetailsCache = [{
    line: 1,
    column: 1
  }],
      peg$maxFailPos = 0,
      peg$maxFailExpected = [],
      peg$silentFails = 0,
      peg$result;

  if ("startRule" in options) {
    if (!(options.startRule in peg$startRuleFunctions)) {
      throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
    }

    peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
  }

  function text() {
    return input.substring(peg$savedPos, peg$currPos);
  }

  function location() {
    return peg$computeLocation(peg$savedPos, peg$currPos);
  }

  function expected(description, location) {
    location = location !== void 0 ? location : peg$computeLocation(peg$savedPos, peg$currPos);
    throw peg$buildStructuredError([peg$otherExpectation(description)], input.substring(peg$savedPos, peg$currPos), location);
  }

  function error(message, location) {
    location = location !== void 0 ? location : peg$computeLocation(peg$savedPos, peg$currPos);
    throw peg$buildSimpleError(message, location);
  }

  function peg$literalExpectation(text, ignoreCase) {
    return {
      type: "literal",
      text: text,
      ignoreCase: ignoreCase
    };
  }

  function peg$classExpectation(parts, inverted, ignoreCase) {
    return {
      type: "class",
      parts: parts,
      inverted: inverted,
      ignoreCase: ignoreCase
    };
  }

  function peg$anyExpectation() {
    return {
      type: "any"
    };
  }

  function peg$endExpectation() {
    return {
      type: "end"
    };
  }

  function peg$otherExpectation(description) {
    return {
      type: "other",
      description: description
    };
  }

  function peg$computePosDetails(pos) {
    var details = peg$posDetailsCache[pos],
        p;

    if (details) {
      return details;
    } else {
      p = pos - 1;

      while (!peg$posDetailsCache[p]) {
        p--;
      }

      details = peg$posDetailsCache[p];
      details = {
        line: details.line,
        column: details.column
      };

      while (p < pos) {
        if (input.charCodeAt(p) === 10) {
          details.line++;
          details.column = 1;
        } else {
          details.column++;
        }

        p++;
      }

      peg$posDetailsCache[pos] = details;
      return details;
    }
  }

  function peg$computeLocation(startPos, endPos) {
    var startPosDetails = peg$computePosDetails(startPos),
        endPosDetails = peg$computePosDetails(endPos);
    return {
      start: {
        offset: startPos,
        line: startPosDetails.line,
        column: startPosDetails.column
      },
      end: {
        offset: endPos,
        line: endPosDetails.line,
        column: endPosDetails.column
      }
    };
  }

  function peg$fail(expected) {
    if (peg$currPos < peg$maxFailPos) {
      return;
    }

    if (peg$currPos > peg$maxFailPos) {
      peg$maxFailPos = peg$currPos;
      peg$maxFailExpected = [];
    }

    peg$maxFailExpected.push(expected);
  }

  function peg$buildSimpleError(message, location) {
    return new peg$SyntaxError(message, null, null, location);
  }

  function peg$buildStructuredError(expected, found, location) {
    return new peg$SyntaxError(peg$SyntaxError.buildMessage(expected, found), expected, found, location);
  }

  function peg$parsestart() {
    var s0;
    s0 = peg$parseexpression();
    return s0;
  }

  function peg$parsestart_text() {
    var s0, s1, s2;
    s0 = peg$currPos;
    s1 = [];
    s2 = peg$parsetext_part();

    while (s2 !== peg$FAILED) {
      s1.push(s2);
      s2 = peg$parsetext_part();
    }

    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$c0(s1);
    }

    s0 = s1;
    return s0;
  }

  function peg$parsetext_part() {
    var s0, s1, s2, s3, s4, s5, s6, s7;
    s0 = peg$currPos;

    if (input.substr(peg$currPos, 2) === peg$c1) {
      s1 = peg$c1;
      peg$currPos += 2;
    } else {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c2);
      }
    }

    if (s1 !== peg$FAILED) {
      s2 = peg$parseexpression();

      if (s2 !== peg$FAILED) {
        if (input.substr(peg$currPos, 2) === peg$c3) {
          s3 = peg$c3;
          peg$currPos += 2;
        } else {
          s3 = peg$FAILED;

          if (peg$silentFails === 0) {
            peg$fail(peg$c4);
          }
        }

        if (s3 !== peg$FAILED) {
          s4 = peg$parsesp();

          if (s4 !== peg$FAILED) {
            s5 = [];

            if (peg$c5.test(input.charAt(peg$currPos))) {
              s6 = input.charAt(peg$currPos);
              peg$currPos++;
            } else {
              s6 = peg$FAILED;

              if (peg$silentFails === 0) {
                peg$fail(peg$c6);
              }
            }

            if (s6 !== peg$FAILED) {
              while (s6 !== peg$FAILED) {
                s5.push(s6);

                if (peg$c5.test(input.charAt(peg$currPos))) {
                  s6 = input.charAt(peg$currPos);
                  peg$currPos++;
                } else {
                  s6 = peg$FAILED;

                  if (peg$silentFails === 0) {
                    peg$fail(peg$c6);
                  }
                }
              }
            } else {
              s5 = peg$FAILED;
            }

            if (s5 !== peg$FAILED) {
              s6 = peg$parsesp();

              if (s6 !== peg$FAILED) {
                if (input.charCodeAt(peg$currPos) === 125) {
                  s7 = peg$c7;
                  peg$currPos++;
                } else {
                  s7 = peg$FAILED;

                  if (peg$silentFails === 0) {
                    peg$fail(peg$c8);
                  }
                }

                if (s7 !== peg$FAILED) {
                  peg$savedPos = s0;
                  s1 = peg$c9(s2, s5);
                  s0 = s1;
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    if (s0 === peg$FAILED) {
      s0 = peg$currPos;

      if (input.substr(peg$currPos, 2) === peg$c1) {
        s1 = peg$c1;
        peg$currPos += 2;
      } else {
        s1 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c2);
        }
      }

      if (s1 !== peg$FAILED) {
        s2 = peg$parseexpression();

        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 125) {
            s3 = peg$c7;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;

            if (peg$silentFails === 0) {
              peg$fail(peg$c8);
            }
          }

          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c10(s2);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = [];
        s2 = peg$parsetext_plain();

        if (s2 !== peg$FAILED) {
          while (s2 !== peg$FAILED) {
            s1.push(s2);
            s2 = peg$parsetext_plain();
          }
        } else {
          s1 = peg$FAILED;
        }

        if (s1 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c11(s1);
        }

        s0 = s1;
      }
    }

    return s0;
  }

  function peg$parsetext_plain() {
    var s0, s1, s2;
    s0 = peg$currPos;
    s1 = [];

    if (peg$c12.test(input.charAt(peg$currPos))) {
      s2 = input.charAt(peg$currPos);
      peg$currPos++;
    } else {
      s2 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c13);
      }
    }

    if (s2 !== peg$FAILED) {
      while (s2 !== peg$FAILED) {
        s1.push(s2);

        if (peg$c12.test(input.charAt(peg$currPos))) {
          s2 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s2 = peg$FAILED;

          if (peg$silentFails === 0) {
            peg$fail(peg$c13);
          }
        }
      }
    } else {
      s1 = peg$FAILED;
    }

    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$c14(s1);
    }

    s0 = s1;

    if (s0 === peg$FAILED) {
      s0 = peg$currPos;

      if (input.charCodeAt(peg$currPos) === 92) {
        s1 = peg$c15;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c16);
        }
      }

      if (s1 !== peg$FAILED) {
        if (peg$c17.test(input.charAt(peg$currPos))) {
          s2 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s2 = peg$FAILED;

          if (peg$silentFails === 0) {
            peg$fail(peg$c18);
          }
        }

        if (s2 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c19(s2);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    }

    return s0;
  }

  function peg$parseexpression() {
    var s0, s1, s2, s3;
    s0 = peg$currPos;
    s1 = peg$parsesp();

    if (s1 !== peg$FAILED) {
      s2 = peg$parselevel_expression();

      if (s2 !== peg$FAILED) {
        s3 = peg$parsesp();

        if (s3 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c20(s2);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parselevel_expression() {
    var s0, s1;
    s0 = peg$currPos;
    s1 = peg$parselevelm0();

    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$c20(s1);
    }

    s0 = s1;
    return s0;
  }

  function peg$parselogic_operators() {
    var s0, s1;
    peg$silentFails++;

    if (input.substr(peg$currPos, 3) === peg$c22) {
      s0 = peg$c22;
      peg$currPos += 3;
    } else {
      s0 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c23);
      }
    }

    if (s0 === peg$FAILED) {
      if (input.substr(peg$currPos, 2) === peg$c24) {
        s0 = peg$c24;
        peg$currPos += 2;
      } else {
        s0 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c25);
        }
      }
    }

    peg$silentFails--;

    if (s0 === peg$FAILED) {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c21);
      }
    }

    return s0;
  }

  function peg$parsecompare_operators() {
    var s0, s1;
    peg$silentFails++;

    if (input.substr(peg$currPos, 2) === peg$c26) {
      s0 = peg$c26;
      peg$currPos += 2;
    } else {
      s0 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c27);
      }
    }

    if (s0 === peg$FAILED) {
      if (input.charCodeAt(peg$currPos) === 62) {
        s0 = peg$c28;
        peg$currPos++;
      } else {
        s0 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c29);
        }
      }

      if (s0 === peg$FAILED) {
        if (input.substr(peg$currPos, 2) === peg$c30) {
          s0 = peg$c30;
          peg$currPos += 2;
        } else {
          s0 = peg$FAILED;

          if (peg$silentFails === 0) {
            peg$fail(peg$c31);
          }
        }

        if (s0 === peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 60) {
            s0 = peg$c32;
            peg$currPos++;
          } else {
            s0 = peg$FAILED;

            if (peg$silentFails === 0) {
              peg$fail(peg$c33);
            }
          }

          if (s0 === peg$FAILED) {
            if (input.substr(peg$currPos, 2) === peg$c34) {
              s0 = peg$c34;
              peg$currPos += 2;
            } else {
              s0 = peg$FAILED;

              if (peg$silentFails === 0) {
                peg$fail(peg$c35);
              }
            }

            if (s0 === peg$FAILED) {
              if (input.substr(peg$currPos, 2) === peg$c36) {
                s0 = peg$c36;
                peg$currPos += 2;
              } else {
                s0 = peg$FAILED;

                if (peg$silentFails === 0) {
                  peg$fail(peg$c37);
                }
              }

              if (s0 === peg$FAILED) {
                if (input.substr(peg$currPos, 2) === peg$c38) {
                  s0 = peg$c38;
                  peg$currPos += 2;
                } else {
                  s0 = peg$FAILED;

                  if (peg$silentFails === 0) {
                    peg$fail(peg$c39);
                  }
                }
              }
            }
          }
        }
      }
    }

    peg$silentFails--;

    if (s0 === peg$FAILED) {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c21);
      }
    }

    return s0;
  }

  function peg$parselevel1_operators() {
    var s0, s1;
    peg$silentFails++;

    if (input.charCodeAt(peg$currPos) === 43) {
      s0 = peg$c40;
      peg$currPos++;
    } else {
      s0 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c41);
      }
    }

    if (s0 === peg$FAILED) {
      if (input.charCodeAt(peg$currPos) === 45) {
        s0 = peg$c42;
        peg$currPos++;
      } else {
        s0 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c43);
        }
      }
    }

    peg$silentFails--;

    if (s0 === peg$FAILED) {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c21);
      }
    }

    return s0;
  }

  function peg$parselevel2_operators() {
    var s0, s1;
    peg$silentFails++;

    if (input.charCodeAt(peg$currPos) === 42) {
      s0 = peg$c44;
      peg$currPos++;
    } else {
      s0 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c45);
      }
    }

    if (s0 === peg$FAILED) {
      if (input.charCodeAt(peg$currPos) === 47) {
        s0 = peg$c46;
        peg$currPos++;
      } else {
        s0 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c47);
        }
      }
    }

    peg$silentFails--;

    if (s0 === peg$FAILED) {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c21);
      }
    }

    return s0;
  }

  function peg$parselevel3_operators() {
    var s0, s1;
    peg$silentFails++;

    if (input.charCodeAt(peg$currPos) === 94) {
      s0 = peg$c48;
      peg$currPos++;
    } else {
      s0 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c49);
      }
    }

    peg$silentFails--;

    if (s0 === peg$FAILED) {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c21);
      }
    }

    return s0;
  }

  function peg$parseunary_operators() {
    var s0, s1;
    peg$silentFails++;

    if (input.charCodeAt(peg$currPos) === 45) {
      s0 = peg$c42;
      peg$currPos++;
    } else {
      s0 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c43);
      }
    }

    if (s0 === peg$FAILED) {
      if (input.charCodeAt(peg$currPos) === 43) {
        s0 = peg$c40;
        peg$currPos++;
      } else {
        s0 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c41);
        }
      }
    }

    peg$silentFails--;

    if (s0 === peg$FAILED) {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c21);
      }
    }

    return s0;
  }

  function peg$parselevelm0() {
    var s0, s1, s2, s3, s4, s5, s6, s7;
    s0 = peg$currPos;

    if (input.substr(peg$currPos, 3) === peg$c50) {
      s1 = peg$c50;
      peg$currPos += 3;
    } else {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c51);
      }
    }

    if (s1 !== peg$FAILED) {
      s2 = peg$parsesp();

      if (s2 !== peg$FAILED) {
        s3 = peg$parselevelm0();

        if (s3 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c52(s3);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$parselevel0();

      if (s1 !== peg$FAILED) {
        s2 = [];
        s3 = peg$currPos;
        s4 = peg$parsesp();

        if (s4 !== peg$FAILED) {
          s5 = peg$parselogic_operators();

          if (s5 !== peg$FAILED) {
            s6 = peg$parsesp();

            if (s6 !== peg$FAILED) {
              s7 = peg$parselevel0();

              if (s7 !== peg$FAILED) {
                s4 = [s4, s5, s6, s7];
                s3 = s4;
              } else {
                peg$currPos = s3;
                s3 = peg$FAILED;
              }
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }

        while (s3 !== peg$FAILED) {
          s2.push(s3);
          s3 = peg$currPos;
          s4 = peg$parsesp();

          if (s4 !== peg$FAILED) {
            s5 = peg$parselogic_operators();

            if (s5 !== peg$FAILED) {
              s6 = peg$parsesp();

              if (s6 !== peg$FAILED) {
                s7 = peg$parselevel0();

                if (s7 !== peg$FAILED) {
                  s4 = [s4, s5, s6, s7];
                  s3 = s4;
                } else {
                  peg$currPos = s3;
                  s3 = peg$FAILED;
                }
              } else {
                peg$currPos = s3;
                s3 = peg$FAILED;
              }
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        }

        if (s2 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c53(s1, s2);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    }

    return s0;
  }

  function peg$parselevel0() {
    var s0, s1, s2, s3, s4, s5, s6, s7;
    s0 = peg$currPos;
    s1 = peg$parselevel1();

    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$currPos;
      s4 = peg$parsesp();

      if (s4 !== peg$FAILED) {
        s5 = peg$parsecompare_operators();

        if (s5 !== peg$FAILED) {
          s6 = peg$parsesp();

          if (s6 !== peg$FAILED) {
            s7 = peg$parselevel1();

            if (s7 !== peg$FAILED) {
              s4 = [s4, s5, s6, s7];
              s3 = s4;
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }

      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$currPos;
        s4 = peg$parsesp();

        if (s4 !== peg$FAILED) {
          s5 = peg$parsecompare_operators();

          if (s5 !== peg$FAILED) {
            s6 = peg$parsesp();

            if (s6 !== peg$FAILED) {
              s7 = peg$parselevel1();

              if (s7 !== peg$FAILED) {
                s4 = [s4, s5, s6, s7];
                s3 = s4;
              } else {
                peg$currPos = s3;
                s3 = peg$FAILED;
              }
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      }

      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c53(s1, s2);
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parselevel1() {
    var s0, s1, s2, s3, s4, s5, s6, s7;
    s0 = peg$currPos;
    s1 = peg$parselevel2();

    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$currPos;
      s4 = peg$parsesp();

      if (s4 !== peg$FAILED) {
        s5 = peg$parselevel1_operators();

        if (s5 !== peg$FAILED) {
          s6 = peg$parsesp();

          if (s6 !== peg$FAILED) {
            s7 = peg$parselevel2();

            if (s7 !== peg$FAILED) {
              s4 = [s4, s5, s6, s7];
              s3 = s4;
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }

      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$currPos;
        s4 = peg$parsesp();

        if (s4 !== peg$FAILED) {
          s5 = peg$parselevel1_operators();

          if (s5 !== peg$FAILED) {
            s6 = peg$parsesp();

            if (s6 !== peg$FAILED) {
              s7 = peg$parselevel2();

              if (s7 !== peg$FAILED) {
                s4 = [s4, s5, s6, s7];
                s3 = s4;
              } else {
                peg$currPos = s3;
                s3 = peg$FAILED;
              }
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      }

      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c53(s1, s2);
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parselevel2() {
    var s0, s1, s2, s3, s4, s5, s6, s7;
    s0 = peg$currPos;
    s1 = peg$parselevel3();

    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$currPos;
      s4 = peg$parsesp();

      if (s4 !== peg$FAILED) {
        s5 = peg$parselevel2_operators();

        if (s5 !== peg$FAILED) {
          s6 = peg$parsesp();

          if (s6 !== peg$FAILED) {
            s7 = peg$parselevel3();

            if (s7 !== peg$FAILED) {
              s4 = [s4, s5, s6, s7];
              s3 = s4;
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }

      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$currPos;
        s4 = peg$parsesp();

        if (s4 !== peg$FAILED) {
          s5 = peg$parselevel2_operators();

          if (s5 !== peg$FAILED) {
            s6 = peg$parsesp();

            if (s6 !== peg$FAILED) {
              s7 = peg$parselevel3();

              if (s7 !== peg$FAILED) {
                s4 = [s4, s5, s6, s7];
                s3 = s4;
              } else {
                peg$currPos = s3;
                s3 = peg$FAILED;
              }
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      }

      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c53(s1, s2);
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parselevel3() {
    var s0, s1, s2, s3, s4, s5, s6, s7;
    s0 = peg$currPos;
    s1 = peg$parselevel4();

    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$currPos;
      s4 = peg$parsesp();

      if (s4 !== peg$FAILED) {
        s5 = peg$parselevel3_operators();

        if (s5 !== peg$FAILED) {
          s6 = peg$parsesp();

          if (s6 !== peg$FAILED) {
            s7 = peg$parselevel4();

            if (s7 !== peg$FAILED) {
              s4 = [s4, s5, s6, s7];
              s3 = s4;
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }

      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$currPos;
        s4 = peg$parsesp();

        if (s4 !== peg$FAILED) {
          s5 = peg$parselevel3_operators();

          if (s5 !== peg$FAILED) {
            s6 = peg$parsesp();

            if (s6 !== peg$FAILED) {
              s7 = peg$parselevel4();

              if (s7 !== peg$FAILED) {
                s4 = [s4, s5, s6, s7];
                s3 = s4;
              } else {
                peg$currPos = s3;
                s3 = peg$FAILED;
              }
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      }

      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c53(s1, s2);
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parselevel4() {
    var s0, s1, s2, s3;
    s0 = peg$parseitem();

    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$parseunary_operators();

      if (s1 !== peg$FAILED) {
        s2 = peg$parsesp();

        if (s2 !== peg$FAILED) {
          s3 = peg$parselevel4();

          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c54(s1, s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    }

    return s0;
  }

  function peg$parsebegin_braket() {
    var s0, s1;
    peg$silentFails++;

    if (input.charCodeAt(peg$currPos) === 40) {
      s0 = peg$c56;
      peg$currPos++;
    } else {
      s0 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c57);
      }
    }

    peg$silentFails--;

    if (s0 === peg$FAILED) {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c55);
      }
    }

    return s0;
  }

  function peg$parseend_braket() {
    var s0, s1;
    peg$silentFails++;

    if (input.charCodeAt(peg$currPos) === 41) {
      s0 = peg$c59;
      peg$currPos++;
    } else {
      s0 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c60);
      }
    }

    peg$silentFails--;

    if (s0 === peg$FAILED) {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c58);
      }
    }

    return s0;
  }

  function peg$parsecomma() {
    var s0, s1;
    peg$silentFails++;

    if (input.charCodeAt(peg$currPos) === 44) {
      s0 = peg$c62;
      peg$currPos++;
    } else {
      s0 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c63);
      }
    }

    peg$silentFails--;

    if (s0 === peg$FAILED) {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c61);
      }
    }

    return s0;
  }

  function peg$parsedot() {
    var s0, s1;
    peg$silentFails++;

    if (input.charCodeAt(peg$currPos) === 46) {
      s0 = peg$c65;
      peg$currPos++;
    } else {
      s0 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c66);
      }
    }

    peg$silentFails--;

    if (s0 === peg$FAILED) {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c64);
      }
    }

    return s0;
  }

  function peg$parsebraket_expression() {
    var s0, s1, s2, s3, s4, s5;
    s0 = peg$currPos;
    s1 = peg$parsebegin_braket();

    if (s1 !== peg$FAILED) {
      s2 = peg$parsesp();

      if (s2 !== peg$FAILED) {
        s3 = peg$parselevelm0();

        if (s3 !== peg$FAILED) {
          s4 = peg$parsesp();

          if (s4 !== peg$FAILED) {
            s5 = peg$parseend_braket();

            if (s5 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c20(s3);
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseitem() {
    var s0;
    s0 = peg$parseprimitive();

    if (s0 === peg$FAILED) {
      s0 = peg$parsefunction_call();

      if (s0 === peg$FAILED) {
        s0 = peg$parselambda_function();

        if (s0 === peg$FAILED) {
          s0 = peg$parsefieldaccess();

          if (s0 === peg$FAILED) {
            s0 = peg$parsevariable();

            if (s0 === peg$FAILED) {
              s0 = peg$parsebraket_expression();
            }
          }
        }
      }
    }

    return s0;
  }

  function peg$parsefieldable() {
    var s0;
    s0 = peg$parsevariable();

    if (s0 === peg$FAILED) {
      s0 = peg$parsebraket_expression();
    }

    return s0;
  }

  function peg$parsefieldaccess() {
    var s0, s1, s2, s3, s4, s5, s6, s7;
    s0 = peg$currPos;
    s1 = peg$parsefieldable();

    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$currPos;
      s4 = peg$parsesp();

      if (s4 !== peg$FAILED) {
        s5 = peg$parsedot();

        if (s5 !== peg$FAILED) {
          s6 = peg$parsesp();

          if (s6 !== peg$FAILED) {
            s7 = peg$parsevariable_name();

            if (s7 !== peg$FAILED) {
              s4 = [s4, s5, s6, s7];
              s3 = s4;
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }

      if (s3 !== peg$FAILED) {
        while (s3 !== peg$FAILED) {
          s2.push(s3);
          s3 = peg$currPos;
          s4 = peg$parsesp();

          if (s4 !== peg$FAILED) {
            s5 = peg$parsedot();

            if (s5 !== peg$FAILED) {
              s6 = peg$parsesp();

              if (s6 !== peg$FAILED) {
                s7 = peg$parsevariable_name();

                if (s7 !== peg$FAILED) {
                  s4 = [s4, s5, s6, s7];
                  s3 = s4;
                } else {
                  peg$currPos = s3;
                  s3 = peg$FAILED;
                }
              } else {
                peg$currPos = s3;
                s3 = peg$FAILED;
              }
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        }
      } else {
        s2 = peg$FAILED;
      }

      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c67(s1, s2);
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parsefuncitem() {
    var s0;
    s0 = peg$parsefieldaccess();

    if (s0 === peg$FAILED) {
      s0 = peg$parsevariable();

      if (s0 === peg$FAILED) {
        s0 = peg$parsebraket_expression();
      }
    }

    return s0;
  }

  function peg$parsefuncname() {
    var s0, s1, s2, s3, s4, s5;
    s0 = peg$currPos;
    s1 = peg$parsevariable_name();

    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$currPos;

      if (input.charCodeAt(peg$currPos) === 46) {
        s4 = peg$c65;
        peg$currPos++;
      } else {
        s4 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c66);
        }
      }

      if (s4 !== peg$FAILED) {
        s5 = peg$parsevariable_name();

        if (s5 !== peg$FAILED) {
          s4 = [s4, s5];
          s3 = s4;
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }

      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$currPos;

        if (input.charCodeAt(peg$currPos) === 46) {
          s4 = peg$c65;
          peg$currPos++;
        } else {
          s4 = peg$FAILED;

          if (peg$silentFails === 0) {
            peg$fail(peg$c66);
          }
        }

        if (s4 !== peg$FAILED) {
          s5 = peg$parsevariable_name();

          if (s5 !== peg$FAILED) {
            s4 = [s4, s5];
            s3 = s4;
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      }

      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c68(s1, s2);
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parsevariable() {
    var s0, s1;
    peg$silentFails++;
    s0 = peg$currPos;
    s1 = peg$parsevariable_name();

    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$c70(s1);
    }

    s0 = s1;
    peg$silentFails--;

    if (s0 === peg$FAILED) {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c69);
      }
    }

    return s0;
  }

  function peg$parseargitem() {
    var s0, s1;
    s0 = peg$currPos;
    s1 = peg$parselevel_expression();

    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$c71(s1);
    }

    s0 = s1;
    return s0;
  }

  function peg$parseargitems() {
    var s0, s1, s2, s3, s4, s5;
    s0 = peg$currPos;
    s1 = peg$parseargitem();

    if (s1 !== peg$FAILED) {
      s2 = peg$parsesp();

      if (s2 !== peg$FAILED) {
        s3 = peg$parsecomma();

        if (s3 !== peg$FAILED) {
          s4 = peg$parsesp();

          if (s4 !== peg$FAILED) {
            s5 = peg$parseargitems();

            if (s5 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c72(s1, s5);
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$parseargitem();

      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c71(s1);
      }

      s0 = s1;
    }

    return s0;
  }

  function peg$parseargitem_list() {
    var s0, s1, s2, s3, s4, s5;
    s0 = peg$currPos;
    s1 = peg$parsebegin_braket();

    if (s1 !== peg$FAILED) {
      s2 = peg$parsesp();

      if (s2 !== peg$FAILED) {
        s3 = peg$parseargitems();

        if (s3 !== peg$FAILED) {
          s4 = peg$parsesp();

          if (s4 !== peg$FAILED) {
            s5 = peg$parseend_braket();

            if (s5 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c73(s3);
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    if (s0 === peg$FAILED) {
      s0 = peg$currPos;

      if (input.charCodeAt(peg$currPos) === 40) {
        s1 = peg$c56;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c57);
        }
      }

      if (s1 !== peg$FAILED) {
        s2 = peg$parsesp();

        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 41) {
            s3 = peg$c59;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;

            if (peg$silentFails === 0) {
              peg$fail(peg$c60);
            }
          }

          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c74();
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    }

    return s0;
  }

  function peg$parsefunction_call() {
    var s0, s1, s2, s3;
    s0 = peg$currPos;
    s1 = peg$parsefuncname();

    if (s1 !== peg$FAILED) {
      s2 = peg$parsesp();

      if (s2 !== peg$FAILED) {
        s3 = peg$parseargitem_list();

        if (s3 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c75(s1, s3);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseargnames() {
    var s0, s1, s2, s3, s4, s5;
    s0 = peg$currPos;
    s1 = peg$parsevariable_name();

    if (s1 !== peg$FAILED) {
      s2 = peg$parsesp();

      if (s2 !== peg$FAILED) {
        s3 = peg$parsecomma();

        if (s3 !== peg$FAILED) {
          s4 = peg$parsesp();

          if (s4 !== peg$FAILED) {
            s5 = peg$parseargnames();

            if (s5 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c72(s1, s5);
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$parsevariable_name();

      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c71(s1);
      }

      s0 = s1;
    }

    return s0;
  }

  function peg$parselambda_function() {
    var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9;
    s0 = peg$currPos;
    s1 = peg$parsebegin_braket();

    if (s1 !== peg$FAILED) {
      s2 = peg$parsesp();

      if (s2 !== peg$FAILED) {
        s3 = peg$parseargnames();

        if (s3 !== peg$FAILED) {
          s4 = peg$parsesp();

          if (s4 !== peg$FAILED) {
            s5 = peg$parseend_braket();

            if (s5 !== peg$FAILED) {
              s6 = peg$parsesp();

              if (s6 !== peg$FAILED) {
                if (input.substr(peg$currPos, 2) === peg$c76) {
                  s7 = peg$c76;
                  peg$currPos += 2;
                } else {
                  s7 = peg$FAILED;

                  if (peg$silentFails === 0) {
                    peg$fail(peg$c77);
                  }
                }

                if (s7 !== peg$FAILED) {
                  s8 = peg$parsesp();

                  if (s8 !== peg$FAILED) {
                    s9 = peg$parseexpression();

                    if (s9 !== peg$FAILED) {
                      peg$savedPos = s0;
                      s1 = peg$c78(s3, s9);
                      s0 = s1;
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$parsevariable_name();

      if (s1 !== peg$FAILED) {
        s2 = peg$parsesp();

        if (s2 !== peg$FAILED) {
          if (input.substr(peg$currPos, 2) === peg$c76) {
            s3 = peg$c76;
            peg$currPos += 2;
          } else {
            s3 = peg$FAILED;

            if (peg$silentFails === 0) {
              peg$fail(peg$c77);
            }
          }

          if (s3 !== peg$FAILED) {
            s4 = peg$parsesp();

            if (s4 !== peg$FAILED) {
              s5 = peg$parseexpression();

              if (s5 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c79(s1, s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    }

    return s0;
  }

  function peg$parseprimitive() {
    var s0, s1;
    peg$silentFails++;
    s0 = peg$parsefloating_point();

    if (s0 === peg$FAILED) {
      s0 = peg$parseboolean();

      if (s0 === peg$FAILED) {
        s0 = peg$parsestring();
      }
    }

    peg$silentFails--;

    if (s0 === peg$FAILED) {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c80);
      }
    }

    return s0;
  }

  function peg$parsefloating_point() {
    var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9;
    peg$silentFails++;
    s0 = peg$currPos;
    s1 = peg$currPos;

    if (peg$c82.test(input.charAt(peg$currPos))) {
      s2 = input.charAt(peg$currPos);
      peg$currPos++;
    } else {
      s2 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c83);
      }
    }

    if (s2 === peg$FAILED) {
      s2 = null;
    }

    if (s2 !== peg$FAILED) {
      s3 = [];

      if (peg$c84.test(input.charAt(peg$currPos))) {
        s4 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s4 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c85);
        }
      }

      if (s4 !== peg$FAILED) {
        while (s4 !== peg$FAILED) {
          s3.push(s4);

          if (peg$c84.test(input.charAt(peg$currPos))) {
            s4 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s4 = peg$FAILED;

            if (peg$silentFails === 0) {
              peg$fail(peg$c85);
            }
          }
        }
      } else {
        s3 = peg$FAILED;
      }

      if (s3 !== peg$FAILED) {
        s4 = peg$currPos;

        if (input.charCodeAt(peg$currPos) === 46) {
          s5 = peg$c65;
          peg$currPos++;
        } else {
          s5 = peg$FAILED;

          if (peg$silentFails === 0) {
            peg$fail(peg$c66);
          }
        }

        if (s5 !== peg$FAILED) {
          s6 = [];

          if (peg$c84.test(input.charAt(peg$currPos))) {
            s7 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s7 = peg$FAILED;

            if (peg$silentFails === 0) {
              peg$fail(peg$c85);
            }
          }

          if (s7 !== peg$FAILED) {
            while (s7 !== peg$FAILED) {
              s6.push(s7);

              if (peg$c84.test(input.charAt(peg$currPos))) {
                s7 = input.charAt(peg$currPos);
                peg$currPos++;
              } else {
                s7 = peg$FAILED;

                if (peg$silentFails === 0) {
                  peg$fail(peg$c85);
                }
              }
            }
          } else {
            s6 = peg$FAILED;
          }

          if (s6 !== peg$FAILED) {
            s5 = [s5, s6];
            s4 = s5;
          } else {
            peg$currPos = s4;
            s4 = peg$FAILED;
          }
        } else {
          peg$currPos = s4;
          s4 = peg$FAILED;
        }

        if (s4 === peg$FAILED) {
          s4 = null;
        }

        if (s4 !== peg$FAILED) {
          s5 = peg$currPos;

          if (peg$c86.test(input.charAt(peg$currPos))) {
            s6 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s6 = peg$FAILED;

            if (peg$silentFails === 0) {
              peg$fail(peg$c87);
            }
          }

          if (s6 !== peg$FAILED) {
            if (peg$c82.test(input.charAt(peg$currPos))) {
              s7 = input.charAt(peg$currPos);
              peg$currPos++;
            } else {
              s7 = peg$FAILED;

              if (peg$silentFails === 0) {
                peg$fail(peg$c83);
              }
            }

            if (s7 === peg$FAILED) {
              s7 = null;
            }

            if (s7 !== peg$FAILED) {
              s8 = [];

              if (peg$c84.test(input.charAt(peg$currPos))) {
                s9 = input.charAt(peg$currPos);
                peg$currPos++;
              } else {
                s9 = peg$FAILED;

                if (peg$silentFails === 0) {
                  peg$fail(peg$c85);
                }
              }

              if (s9 !== peg$FAILED) {
                while (s9 !== peg$FAILED) {
                  s8.push(s9);

                  if (peg$c84.test(input.charAt(peg$currPos))) {
                    s9 = input.charAt(peg$currPos);
                    peg$currPos++;
                  } else {
                    s9 = peg$FAILED;

                    if (peg$silentFails === 0) {
                      peg$fail(peg$c85);
                    }
                  }
                }
              } else {
                s8 = peg$FAILED;
              }

              if (s8 !== peg$FAILED) {
                s6 = [s6, s7, s8];
                s5 = s6;
              } else {
                peg$currPos = s5;
                s5 = peg$FAILED;
              }
            } else {
              peg$currPos = s5;
              s5 = peg$FAILED;
            }
          } else {
            peg$currPos = s5;
            s5 = peg$FAILED;
          }

          if (s5 === peg$FAILED) {
            s5 = null;
          }

          if (s5 !== peg$FAILED) {
            s2 = [s2, s3, s4, s5];
            s1 = s2;
          } else {
            peg$currPos = s1;
            s1 = peg$FAILED;
          }
        } else {
          peg$currPos = s1;
          s1 = peg$FAILED;
        }
      } else {
        peg$currPos = s1;
        s1 = peg$FAILED;
      }
    } else {
      peg$currPos = s1;
      s1 = peg$FAILED;
    }

    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$c88(s1);
    }

    s0 = s1;
    peg$silentFails--;

    if (s0 === peg$FAILED) {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c81);
      }
    }

    return s0;
  }

  function peg$parseboolean() {
    var s0, s1;
    peg$silentFails++;
    s0 = peg$currPos;

    if (input.substr(peg$currPos, 4) === peg$c90) {
      s1 = peg$c90;
      peg$currPos += 4;
    } else {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c91);
      }
    }

    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$c92();
    }

    s0 = s1;

    if (s0 === peg$FAILED) {
      s0 = peg$currPos;

      if (input.substr(peg$currPos, 5) === peg$c93) {
        s1 = peg$c93;
        peg$currPos += 5;
      } else {
        s1 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c94);
        }
      }

      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c95();
      }

      s0 = s1;
    }

    peg$silentFails--;

    if (s0 === peg$FAILED) {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c89);
      }
    }

    return s0;
  }

  function peg$parsestring() {
    var s0, s1, s2, s3, s4;
    peg$silentFails++;
    s0 = peg$currPos;
    s1 = peg$currPos;

    if (input.charCodeAt(peg$currPos) === 34) {
      s2 = peg$c97;
      peg$currPos++;
    } else {
      s2 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c98);
      }
    }

    if (s2 !== peg$FAILED) {
      s3 = [];

      if (peg$c99.test(input.charAt(peg$currPos))) {
        s4 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s4 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c100);
        }
      }

      while (s4 !== peg$FAILED) {
        s3.push(s4);

        if (peg$c99.test(input.charAt(peg$currPos))) {
          s4 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s4 = peg$FAILED;

          if (peg$silentFails === 0) {
            peg$fail(peg$c100);
          }
        }
      }

      if (s3 !== peg$FAILED) {
        if (input.charCodeAt(peg$currPos) === 34) {
          s4 = peg$c97;
          peg$currPos++;
        } else {
          s4 = peg$FAILED;

          if (peg$silentFails === 0) {
            peg$fail(peg$c98);
          }
        }

        if (s4 !== peg$FAILED) {
          s2 = [s2, s3, s4];
          s1 = s2;
        } else {
          peg$currPos = s1;
          s1 = peg$FAILED;
        }
      } else {
        peg$currPos = s1;
        s1 = peg$FAILED;
      }
    } else {
      peg$currPos = s1;
      s1 = peg$FAILED;
    }

    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$c101(s1);
    }

    s0 = s1;
    peg$silentFails--;

    if (s0 === peg$FAILED) {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c96);
      }
    }

    return s0;
  }

  function peg$parsevariable_name() {
    var s0, s1, s2, s3, s4;
    peg$silentFails++;
    s0 = peg$currPos;
    s1 = peg$currPos;

    if (peg$c103.test(input.charAt(peg$currPos))) {
      s2 = input.charAt(peg$currPos);
      peg$currPos++;
    } else {
      s2 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c104);
      }
    }

    if (s2 !== peg$FAILED) {
      s3 = [];

      if (peg$c105.test(input.charAt(peg$currPos))) {
        s4 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s4 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c106);
        }
      }

      while (s4 !== peg$FAILED) {
        s3.push(s4);

        if (peg$c105.test(input.charAt(peg$currPos))) {
          s4 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s4 = peg$FAILED;

          if (peg$silentFails === 0) {
            peg$fail(peg$c106);
          }
        }
      }

      if (s3 !== peg$FAILED) {
        s2 = [s2, s3];
        s1 = s2;
      } else {
        peg$currPos = s1;
        s1 = peg$FAILED;
      }
    } else {
      peg$currPos = s1;
      s1 = peg$FAILED;
    }

    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$c107(s1);
    }

    s0 = s1;

    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$currPos;

      if (input.charCodeAt(peg$currPos) === 96) {
        s2 = peg$c108;
        peg$currPos++;
      } else {
        s2 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c109);
        }
      }

      if (s2 !== peg$FAILED) {
        s3 = [];

        if (peg$c110.test(input.charAt(peg$currPos))) {
          s4 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s4 = peg$FAILED;

          if (peg$silentFails === 0) {
            peg$fail(peg$c111);
          }
        }

        while (s4 !== peg$FAILED) {
          s3.push(s4);

          if (peg$c110.test(input.charAt(peg$currPos))) {
            s4 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s4 = peg$FAILED;

            if (peg$silentFails === 0) {
              peg$fail(peg$c111);
            }
          }
        }

        if (s3 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 96) {
            s4 = peg$c108;
            peg$currPos++;
          } else {
            s4 = peg$FAILED;

            if (peg$silentFails === 0) {
              peg$fail(peg$c109);
            }
          }

          if (s4 !== peg$FAILED) {
            s2 = [s2, s3, s4];
            s1 = s2;
          } else {
            peg$currPos = s1;
            s1 = peg$FAILED;
          }
        } else {
          peg$currPos = s1;
          s1 = peg$FAILED;
        }
      } else {
        peg$currPos = s1;
        s1 = peg$FAILED;
      }

      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c112(s1);
      }

      s0 = s1;
    }

    peg$silentFails--;

    if (s0 === peg$FAILED) {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c102);
      }
    }

    return s0;
  }

  function peg$parsesp() {
    var s0, s1;
    peg$silentFails++;
    s0 = [];

    if (peg$c114.test(input.charAt(peg$currPos))) {
      s1 = input.charAt(peg$currPos);
      peg$currPos++;
    } else {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c115);
      }
    }

    while (s1 !== peg$FAILED) {
      s0.push(s1);

      if (peg$c114.test(input.charAt(peg$currPos))) {
        s1 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s1 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c115);
        }
      }
    }

    peg$silentFails--;

    if (s0 === peg$FAILED) {
      s1 = peg$FAILED;

      if (peg$silentFails === 0) {
        peg$fail(peg$c113);
      }
    }

    return s0;
  }

  var Expression = require("./classes");

  function flatten(vars) {
    if (vars instanceof Array) {
      var r = "";

      for (var i = 0; i < vars.length; i++) {
        r += flatten(vars[i]);
      }

      return r;
    } else {
      return vars || "";
    }

    ;
  }

  function create_operator(name, lhs, rhs) {
    if (rhs != null) {
      return new Expression.Operator(name, lhs, rhs);
    } else {
      return new Expression.Operator(name, lhs);
    }
  }

  function gen_operator(left, others) {
    var r = left;

    for (var i = 0; i < others.length; i++) {
      var op = flatten(others[i][1]);
      var rh = others[i][3];
      r = create_operator(op, r, rh);
    }

    return r;
  }

  peg$result = peg$startRuleFunction();

  if (peg$result !== peg$FAILED && peg$currPos === input.length) {
    return peg$result;
  } else {
    if (peg$result !== peg$FAILED && peg$currPos < input.length) {
      peg$fail(peg$endExpectation());
    }

    throw peg$buildStructuredError(peg$maxFailExpected, peg$maxFailPos < input.length ? input.charAt(peg$maxFailPos) : null, peg$maxFailPos < input.length ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1) : peg$computeLocation(peg$maxFailPos, peg$maxFailPos));
  }
}

module.exports = {
  SyntaxError: peg$SyntaxError,
  parse: peg$parse
};